module.exports = __webpack_public_path__ + "static/home-hero-d5f84e5f449bb174f982db8377b62d2d.jpg";